import type React from 'react';

import { DoubleArrow as IconArrow } from '../Icons/DoubleArrow';
import './styles.scss';

type AccordionFilter = { label?: string; name?: string; value?: unknown };

type AccordionProps = {
	children?: React.ReactNode;
	open?: boolean;
	title?: React.ReactNode;
	selectedFilters?: AccordionFilter[];
	onToggle?: (open: boolean) => void;
};

export const Accordion = ({
	children,
	open,
	title,
	selectedFilters = [],
	onToggle,
}: AccordionProps) => {
	// Componente completamente controlado por el prop 'open'.
	return (
		<div className={`accordion ${open ? 'is-open' : 'is-close'}`}>
			<div className="accordion__title" onClick={() => onToggle?.(!open)}>
				<div>
					{title}
					{selectedFilters?.length > 0 ? ' ' : ''}
					{selectedFilters?.map((filter, i) => (
						<span key={i}>
							{filter.label ? filter.label : filter.name}
							{': '}
							{String(filter.value ?? '')}
							{' | '}
						</span>
					))}
				</div>
				<div className="accordion__icon">
					<IconArrow></IconArrow>
				</div>
			</div>
			<div className="accordion__children">{children}</div>
		</div>
	);
};
